import {Component} from '@angular/core';
import {AuthService} from '../../user/services/auth/auth.service';
import {environment} from '../../../../environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  isCerf = environment.cerf;
  constructor(public auth: AuthService) { }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/public/login/login.component.ts